module.exports = __webpack_public_path__ + "img/bg_main_l_3.f977c6e6.png";